import React, { Component } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { APPS } from "../constants/apps";
import AppCard from "../components/app-card";
import "./home.css";

const SOCIAL_LINKS = [
  {
    label: "carlosmsilva83@gmail.com",
    href: "mailto:carlosmsilva83@gmail.com",
  },
  {
    label: "X",
    href: "https://twitter.com/racsol",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/racsol/",
  },
  {
    label: "Medium",
    href: "https://medium.com/@racsol",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/carlosmasilva/",
  },
];

const DESKTOP_OVERLAY_MIN_WIDTH = 1025;

class Home extends Component {
  constructor(props) {
    super(props);
    const systemPrefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;
    this.state = {
      lightboxAppId: null,
      lightboxIndex: 0,
      isDesktopOverlay: window.innerWidth >= DESKTOP_OVERLAY_MIN_WIDTH,
      manualTheme: null,
      systemPrefersDark,
    };
    this.screenshotRows = {};
    this.lightboxRef = React.createRef();
    this.lightboxTrackRef = React.createRef();
    this.lightboxCloseButtonRef = React.createRef();
    this.lightboxScrollRaf = null;
    this.lastFocusedElement = null;
    this.setScreenshotRowRef = this.setScreenshotRowRef.bind(this);
    this.scrollScreenshots = this.scrollScreenshots.bind(this);
    this.handleScreenshotKeyDown = this.handleScreenshotKeyDown.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
    this.moveLightbox = this.moveLightbox.bind(this);
    this.centerActiveLightboxImage = this.centerActiveLightboxImage.bind(this);
    this.handleLightboxTrackScroll = this.handleLightboxTrackScroll.bind(this);
    this.handleLightboxKeyDown = this.handleLightboxKeyDown.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
    this.handleSystemThemeChange = this.handleSystemThemeChange.bind(this);
    this.toggleTheme = this.toggleTheme.bind(this);
    this.getResolvedTheme = this.getResolvedTheme.bind(this);
    this.applyThemeToDocument = this.applyThemeToDocument.bind(this);
  }

  componentDidMount() {
    this.lightboxMediaQuery = window.matchMedia(
      `(min-width: ${DESKTOP_OVERLAY_MIN_WIDTH}px)`
    );
    this.handleViewportChange();
    if (this.lightboxMediaQuery.addEventListener) {
      this.lightboxMediaQuery.addEventListener("change", this.handleViewportChange);
    } else {
      this.lightboxMediaQuery.addListener(this.handleViewportChange);
    }
    this.systemThemeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    if (this.systemThemeMediaQuery.addEventListener) {
      this.systemThemeMediaQuery.addEventListener(
        "change",
        this.handleSystemThemeChange
      );
    } else {
      this.systemThemeMediaQuery.addListener(this.handleSystemThemeChange);
    }
    this.applyThemeToDocument();
  }

  componentDidUpdate(prevProps, prevState) {
    const wasOpen = prevState.lightboxAppId !== null;
    const isOpen = this.state.lightboxAppId !== null;

    if (!wasOpen && isOpen) {
      document.addEventListener("keydown", this.handleLightboxKeyDown);
      document.body.classList.add("lightbox-open");
      this.lastFocusedElement =
        document.activeElement instanceof HTMLElement
          ? document.activeElement
          : null;
      if (this.lightboxCloseButtonRef.current) {
        this.lightboxCloseButtonRef.current.focus();
      }
    }

    if (wasOpen && !isOpen) {
      document.removeEventListener("keydown", this.handleLightboxKeyDown);
      document.body.classList.remove("lightbox-open");
      if (this.lastFocusedElement) {
        this.lastFocusedElement.focus();
      }
      this.lastFocusedElement = null;
    }

    if (
      isOpen &&
      !this.state.isDesktopOverlay &&
      (!wasOpen ||
        prevState.lightboxAppId !== this.state.lightboxAppId ||
        prevState.isDesktopOverlay !== this.state.isDesktopOverlay)
    ) {
      this.centerActiveLightboxImage("auto");
    }

    if (
      prevState.manualTheme !== this.state.manualTheme ||
      prevState.systemPrefersDark !== this.state.systemPrefersDark
    ) {
      this.applyThemeToDocument();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleLightboxKeyDown);
    document.body.classList.remove("lightbox-open");
    if (this.lightboxScrollRaf) {
      window.cancelAnimationFrame(this.lightboxScrollRaf);
      this.lightboxScrollRaf = null;
    }
    if (this.lightboxMediaQuery) {
      if (this.lightboxMediaQuery.removeEventListener) {
        this.lightboxMediaQuery.removeEventListener(
          "change",
          this.handleViewportChange
        );
      } else {
        this.lightboxMediaQuery.removeListener(this.handleViewportChange);
      }
    }
    if (this.systemThemeMediaQuery) {
      if (this.systemThemeMediaQuery.removeEventListener) {
        this.systemThemeMediaQuery.removeEventListener(
          "change",
          this.handleSystemThemeChange
        );
      } else {
        this.systemThemeMediaQuery.removeListener(this.handleSystemThemeChange);
      }
    }
  }

  handleViewportChange() {
    const isDesktopOverlay = window.innerWidth >= DESKTOP_OVERLAY_MIN_WIDTH;
    if (this.state.isDesktopOverlay !== isDesktopOverlay) {
      this.setState({ isDesktopOverlay });
    }
  }

  handleSystemThemeChange(event) {
    this.setState({ systemPrefersDark: event.matches });
  }

  getResolvedTheme() {
    const { manualTheme, systemPrefersDark } = this.state;
    if (manualTheme) {
      return manualTheme;
    }
    return systemPrefersDark ? "dark" : "light";
  }

  applyThemeToDocument() {
    document.body.setAttribute("data-theme", this.getResolvedTheme());
  }

  toggleTheme() {
    this.setState((prevState) => {
      const currentTheme = prevState.manualTheme
        ? prevState.manualTheme
        : prevState.systemPrefersDark
          ? "dark"
          : "light";
      return {
        manualTheme: currentTheme === "dark" ? "light" : "dark",
      };
    });
  }

  setScreenshotRowRef(appId, node) {
    this.screenshotRows[appId] = node;
  }

  scrollScreenshots(appId, direction) {
    const row = this.screenshotRows[appId];
    if (!row) {
      return;
    }

    row.scrollBy({
      left: direction * 320,
      behavior: "smooth",
    });
  }

  handleScreenshotKeyDown(appId, event) {
    if (event.key === "ArrowLeft") {
      event.preventDefault();
      this.scrollScreenshots(appId, -1);
    }

    if (event.key === "ArrowRight") {
      event.preventDefault();
      this.scrollScreenshots(appId, 1);
    }
  }

  openLightbox(appId) {
    this.setState({
      lightboxAppId: appId,
      lightboxIndex: 0,
    });
  }

  closeLightbox() {
    this.setState({
      lightboxAppId: null,
      lightboxIndex: 0,
    });
  }

  moveLightbox(direction) {
    this.setState(
      (prevState) => {
        const currentApp = APPS.find((app) => app.id === prevState.lightboxAppId);
        const screenshots =
          currentApp && Array.isArray(currentApp.screenshots)
            ? currentApp.screenshots
            : [];

        if (screenshots.length === 0) {
          return null;
        }

        return {
          lightboxIndex:
            (prevState.lightboxIndex + direction + screenshots.length) %
            screenshots.length,
        };
      },
      () => {
        if (!this.state.isDesktopOverlay) {
          this.centerActiveLightboxImage("smooth");
        }
      }
    );
  }

  centerActiveLightboxImage(behavior = "smooth") {
    const track = this.lightboxTrackRef.current;
    if (!track) {
      return;
    }

    const active = track.querySelector(
      `[data-lightbox-index="${this.state.lightboxIndex}"]`
    );

    if (!active) {
      return;
    }

    active.scrollIntoView({
      behavior,
      block: "nearest",
      inline: "center",
    });
  }

  handleLightboxTrackScroll() {
    if (this.lightboxScrollRaf) {
      return;
    }

    this.lightboxScrollRaf = window.requestAnimationFrame(() => {
      const track = this.lightboxTrackRef.current;
      this.lightboxScrollRaf = null;

      if (!track) {
        return;
      }

      const items = Array.from(track.querySelectorAll(".screenshot-lightbox__item"));
      if (items.length === 0) {
        return;
      }

      const trackCenter = track.scrollLeft + track.clientWidth / 2;
      let closestIndex = this.state.lightboxIndex;
      let closestDistance = Number.POSITIVE_INFINITY;

      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const distance = Math.abs(itemCenter - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      if (closestIndex !== this.state.lightboxIndex) {
        this.setState({ lightboxIndex: closestIndex });
      }
    });
  }

  handleLightboxKeyDown(event) {
    if (event.key === "Escape") {
      event.preventDefault();
      this.closeLightbox();
    }

    if (event.key === "ArrowLeft") {
      event.preventDefault();
      this.moveLightbox(-1);
    }

    if (event.key === "ArrowRight") {
      event.preventDefault();
      this.moveLightbox(1);
    }

    if (event.key === "Tab") {
      const lightboxNode = this.lightboxRef.current;
      if (!lightboxNode) {
        return;
      }

      const focusableNodes = lightboxNode.querySelectorAll(
        'button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'
      );
      const focusable = Array.from(focusableNodes);

      if (focusable.length === 0) {
        event.preventDefault();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      const isInside = lightboxNode.contains(active);

      if (event.shiftKey && (active === first || !isInside)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !isInside)) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  renderThemeSwitcher(isDarkTheme) {
    return (
      <button
        type="button"
        className={`theme-switcher${isDarkTheme ? " theme-switcher--dark" : ""}`}
        onClick={this.toggleTheme}
        role="switch"
        aria-checked={isDarkTheme}
        aria-label={
          isDarkTheme
            ? "Theme is dark. Activate to switch to light mode."
            : "Theme is light. Activate to switch to dark mode."
        }
        title={isDarkTheme ? "Switch to light mode" : "Switch to dark mode"}
      >
        <span className="theme-switcher__thumb" aria-hidden="true">
          {isDarkTheme ? (
            <svg
              className="theme-switcher__icon"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                d="M14.5 3.5a8.5 8.5 0 1 0 6 14.5A9.5 9.5 0 1 1 14.5 3.5z"
                fill="currentColor"
              />
            </svg>
          ) : (
            <svg
              className="theme-switcher__icon"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="4" fill="currentColor" />
              <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="12" y1="1.5" x2="12" y2="4.5" />
                <line x1="12" y1="19.5" x2="12" y2="22.5" />
                <line x1="1.5" y1="12" x2="4.5" y2="12" />
                <line x1="19.5" y1="12" x2="22.5" y2="12" />
                <line x1="4.6" y1="4.6" x2="6.8" y2="6.8" />
                <line x1="17.2" y1="17.2" x2="19.4" y2="19.4" />
                <line x1="17.2" y1="6.8" x2="19.4" y2="4.6" />
                <line x1="4.6" y1="19.4" x2="6.8" y2="17.2" />
              </g>
            </svg>
          )}
        </span>
      </button>
    );
  }

  render() {
    const { lightboxAppId, lightboxIndex, isDesktopOverlay } = this.state;
    const showIntro = this.props.showIntro !== false;
    const showAppsHeader = this.props.showAppsHeader !== false;
    const showThemeButton = Boolean(this.props.showThemeButton);
    const showBackButton = Boolean(this.props.showBackButton);
    const hideWebsiteLink = Boolean(this.props.hideWebsiteLink);
    const showContactLink = Boolean(this.props.showContactLink);
    const contactEmail = this.props.contactEmail || "carlosmsilva83@gmail.com";
    const appIds = Array.isArray(this.props.appIds) ? this.props.appIds : null;
    const visibleApps = appIds
      ? APPS.filter((app) => appIds.includes(app.id))
      : APPS;
    const resolvedTheme = this.getResolvedTheme();
    const isDarkTheme = resolvedTheme === "dark";
    const lightboxApp = visibleApps.find((app) => app.id === lightboxAppId);
    const lightboxScreenshots =
      lightboxApp && Array.isArray(lightboxApp.screenshots)
        ? lightboxApp.screenshots
        : [];
    const lightboxImage = lightboxScreenshots[lightboxIndex];
    const isLightboxOpen = Boolean(
      lightboxApp && Array.isArray(lightboxScreenshots) && lightboxScreenshots.length
    );

    return (
      <>
        <main className="home-page" aria-hidden={isLightboxOpen}>
          <div className="home-page__shape home-page__shape--one" aria-hidden />
          <div className="home-page__shape home-page__shape--two" aria-hidden />
          <div className="home-page__content">
            {!showIntro && showThemeButton ? (
              <div className="home-page__top-actions">
                {this.renderThemeSwitcher(isDarkTheme)}
              </div>
            ) : null}
            {showIntro ? (
              <section
                className="panel panel--intro"
                aria-labelledby="about-me-heading"
              >
                <div className="intro-header">
                  <h1 id="about-me-heading">Carlos Silva</h1>
                  {this.renderThemeSwitcher(isDarkTheme)}
                </div>
                <p className="intro-lead">
                  Frontend Developer and mobile app creator.
                </p>
                <p>
                  I build simple digital products and keep learning new
                  technologies, including Swift and SwiftUI.
                </p>
                <nav aria-label="Social links">
                  <ul className="social-links">
                    {SOCIAL_LINKS.map((link) => (
                      <li key={link.label}>
                        <a
                          className="social-link"
                          href={link.href}
                          target={
                            link.href.startsWith("http") ? "_blank" : undefined
                          }
                          rel={
                            link.href.startsWith("http")
                              ? "noopener noreferrer"
                              : undefined
                          }
                        >
                          {link.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </nav>
              </section>
            ) : null}

            <section
              className="panel panel--apps"
              aria-labelledby={showAppsHeader ? "apps-heading" : undefined}
              aria-label={showAppsHeader ? undefined : "App details"}
            >
              {showAppsHeader ? <h2 id="apps-heading">My Apps</h2> : null}
              {showAppsHeader ? (
                <p className="apps-subtitle">
                  A few apps I build and maintain, focused on practical everyday
                  use.
                </p>
              ) : null}
              <div className="apps-grid">
                {visibleApps.map((app) => (
                  <AppCard
                    app={app}
                    contactEmail={contactEmail}
                    hideWebsiteLink={hideWebsiteLink}
                    key={app.id}
                    onOpenLightbox={this.openLightbox}
                    onScreenshotKeyDown={this.handleScreenshotKeyDown}
                    setScreenshotRowRef={this.setScreenshotRowRef}
                    showContactLink={showContactLink}
                  />
                ))}
              </div>
              {showBackButton ? (
                <div className="apps-back-link-wrap">
                  <Link className="app-card-link apps-back-link" to="/">
                    View all apps
                  </Link>
                </div>
              ) : null}
            </section>
          </div>
        </main>
        {isLightboxOpen
          ? createPortal(
              <div
                className="screenshot-lightbox"
                role="dialog"
                aria-modal="true"
                aria-label={`${lightboxApp.title} screenshots full screen viewer`}
                ref={this.lightboxRef}
                onClick={this.closeLightbox}
              >
                <button
                  type="button"
                  className="screenshot-lightbox__close"
                  onClick={(event) => {
                    event.stopPropagation();
                    this.closeLightbox();
                  }}
                  ref={this.lightboxCloseButtonRef}
                  aria-label="Close full screen screenshot viewer"
                >
                  Close
                </button>
                {isDesktopOverlay ? (
                  <>
                    {lightboxScreenshots.length > 1 ? (
                      <button
                        type="button"
                        className="screenshot-lightbox__nav screenshot-lightbox__nav--prev"
                        onClick={(event) => {
                          event.stopPropagation();
                          this.moveLightbox(-1);
                        }}
                        aria-label="Previous screenshot"
                      >
                        Previous
                      </button>
                    ) : null}
                    {lightboxScreenshots.length > 1 ? (
                      <button
                        type="button"
                        className="screenshot-lightbox__nav screenshot-lightbox__nav--next"
                        onClick={(event) => {
                          event.stopPropagation();
                          this.moveLightbox(1);
                        }}
                        aria-label="Next screenshot"
                      >
                        Next
                      </button>
                    ) : null}
                    <figure
                      className="screenshot-lightbox__figure screenshot-lightbox__figure--desktop"
                      onClick={(event) => event.stopPropagation()}
                    >
                      <img
                        className="screenshot-lightbox__image"
                        src={lightboxImage}
                        alt={`${lightboxApp.title} screenshot ${lightboxIndex + 1}`}
                      />
                      <figcaption className="screenshot-lightbox__caption">
                        {lightboxIndex + 1} of {lightboxScreenshots.length}
                      </figcaption>
                    </figure>
                  </>
                ) : (
                  <figure
                    className="screenshot-lightbox__figure screenshot-lightbox__figure--mobile"
                    onClick={(event) => event.stopPropagation()}
                  >
                    <ul
                      className="screenshot-lightbox__track"
                      ref={this.lightboxTrackRef}
                      aria-label={`${lightboxApp.title} full screen screenshots`}
                      onScroll={this.handleLightboxTrackScroll}
                    >
                      {lightboxScreenshots.map((screenshot, index) => (
                        <li
                          className={`screenshot-lightbox__item${index === lightboxIndex ? " is-active" : ""}`}
                          data-lightbox-index={index}
                          key={`${lightboxApp.id}-lightbox-shot-${index + 1}`}
                        >
                          <div className="screenshot-lightbox__image-frame">
                            <img
                              className="screenshot-lightbox__image"
                              src={screenshot}
                              alt={`${lightboxApp.title} screenshot ${index + 1}`}
                            />
                          </div>
                        </li>
                      ))}
                    </ul>
                    <figcaption className="screenshot-lightbox__caption">
                      {lightboxIndex + 1} of {lightboxScreenshots.length}
                    </figcaption>
                  </figure>
                )}
              </div>,
              document.body
            )
          : null}
      </>
    );
  }
}

export default Home;
